module.exports = __webpack_public_path__ + "static/media/11.5905b204.jpg";